import Logger from './Logger';
import { resolveCtaTag } from './ctaTelemetry';

declare global {
  interface Window {
    __sbCtaClickListenerInstalled?: boolean;
  }
}

function reportCtaClick(event: MouseEvent): void {
  const tag = resolveCtaTag(event.target, window.location);
  if (tag === undefined) return;
  Logger.accessTelemetry()
    .increment(tag)
    .catch(() => undefined);
}

export function installCtaClickListener(): void {
  if (window.__sbCtaClickListenerInstalled) return;
  window.__sbCtaClickListenerInstalled = true;
  document.addEventListener('click', reportCtaClick, true);
}
